import { stripHtml } from "@/utils/stripHTML";

export default {
    computed: {
        productJsonldScript() {
            if (!this.product.photo || !this.product.price) {
                this.__log(`JSON+LD can't be displayed`);
                return null;
            }

            const url = `https://${this.$config.website.domain}${this.$route.path}`;

            const schema = {
                "@context": "https://schema.org",
                "@type": "Product",
                url,
                sku: this.product.id,
                productID: this.product.id,
                image: this.product.photos,
                name: this.product.name,
                description: stripHtml(this.product.description),
                brand: {
                    "@type": "Brand",
                    name: this.$config.website.name,
                },
                ...(this.catalog?.name && { category: this.catalog.name }),
            };

            const priceStr = String(this.product.price);
            const parts = priceStr.split("-").map(Number);
            const isRange = parts.length === 2 && parts.every(n => !isNaN(n));

            const nextYear = new Date();
            nextYear.setFullYear(nextYear.getFullYear() + 1);

            const offer = {
                "@type": isRange ? "AggregateOffer" : "Offer",
                url,
                priceCurrency: "USD",
                priceValidUntil: nextYear.toISOString().split("T")[0],
                availability: `https://schema.org/${this.getHasActiveOffers ? "InStock" : "SoldOut"}`,
                itemCondition: "https://schema.org/NewCondition",
                seller: {
                    "@type": "Organization",
                    name: this.$config.website.name,
                    url: `https://${this.$config.website.domain}`,
                },
            };

            if (isRange) {
                offer.lowPrice = parts[0];
                offer.highPrice = parts[1];
                offer.offerCount = this.product.offers.length;
            } else {
                offer.price = Number(priceStr);
            }

            schema.offers = offer;

            return {
                hid: "product-jsonld",
                type: "application/ld+json",
                innerHTML: JSON.stringify(schema),
            };
        },
    },
}
